import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from '@/components/ui/popover';
import { format, isAfter, isBefore, isEqual } from 'date-fns';

type DateRangePickerProps = {
	startDate: Date | null;
	endDate: Date | null;
	onChange: (start: Date | null, end: Date | null) => void;
};

export const DateRangePickerSplit = ({
	startDate,
	endDate,
	onChange,
}: DateRangePickerProps) => {
	return (
		<div className="flex items-center gap-2">
			<Popover>
				<PopoverTrigger asChild>
					<Button variant="outline">
						{startDate ? format(startDate, 'MM/dd/yyyy') : 'Start Date'}
					</Button>
				</PopoverTrigger>
				<PopoverContent>
					<Calendar
						mode="single"
						selected={startDate || undefined}
						defaultMonth={startDate || undefined}
						onSelect={(date) => onChange(date ?? null, endDate)}
						disabled={(date) =>
							endDate !== null && (isAfter(date, endDate) || isEqual(date, endDate))
						}
					/>
				</PopoverContent>
			</Popover>

			<Popover>
				<PopoverTrigger asChild>
					<Button variant="outline">
						{endDate ? format(endDate, 'MM/dd/yyyy') : 'End Date'}
					</Button>
				</PopoverTrigger>
				<PopoverContent>
					<Calendar
						mode="single"
						selected={endDate || undefined}
						defaultMonth={endDate || undefined}
						onSelect={(date) => onChange(startDate, date ?? null)}
						disabled={(date) =>
							startDate !== null &&
							(isBefore(date, startDate) || isEqual(date, startDate))
						}
					/>
				</PopoverContent>
			</Popover>
		</div>
	);
};
